import React from 'react'
import { DropdownItem } from '../DropdownItem'
import { useUserRole } from '../../store/user/hooks/useUserRole'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const UsersManagement: React.FC = () => {
  const isAdmin = useUserRole() === 'admin'

  if (!isAdmin) {
    return null
  }

  return (
    <DropdownItemWithLink className="e2e-users-management">
      <DropdownLink to="/users">Users management</DropdownLink>
    </DropdownItemWithLink>
  )
}

const DropdownItemWithLink = styled(DropdownItem)`
  padding: 0;
`

const DropdownLink = styled(Link)`
  padding: 10px;
  display: block;
  width: 100%;
  text-decoration: none !important;
`
